import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchShiftDayTimeSlotEntity } from '../../domain/entities/BranchShiftDayTimeSlotEntity'
import moment from 'moment'
import { dayOfWeekOrder } from '@/shared/enums/DayOfWeekOrder'

export class BranchPeriodModel extends BranchShiftDayTimeSlotEntity {
  constructor(dataDto: BranchShiftDayTimeSlotEntity) {
    super()

    const formatTimeValue = (value?: string | Date) => {
      if (!value) return undefined
      if (value instanceof Date) {
        return moment(value).utc().format('HH:mm')
      }

      return moment.utc(value).isValid()
        ? moment.utc(value).format('HH:mm')
        : moment.utc(moment(value, 'HH:mm').format('')).format('HH:mm')
    }

    // Calculate day of week for start time
    const dayOfWeek = dataDto.startTimeDayOfWeek || dataDto.endTimeDayOfWeek

    // Handle start time
    const formattedStartTime = formatTimeValue(dataDto.startTime)

    // Handle end time
    const formattedEndTime = formatTimeValue(dataDto.endTime)

    // Calculate day of week changes for UTC conversion
    let startTimeDayOfWeek = dataDto.startTimeDayOfWeek
    let endTimeDayOfWeek = dataDto.endTimeDayOfWeek

    if (dataDto.startTime && dayOfWeek) {
      const startTimeLocal =
        dataDto.startTime instanceof Date
          ? moment(dataDto.startTime)
          : moment(dataDto.startTime, 'HH:mm')
      const startTimeUtc = moment(startTimeLocal).utc()

      // If UTC day differs from local day
      if (startTimeLocal.format('dddd') !== startTimeUtc.format('dddd')) {
        const dayIndex = dayOfWeekOrder.findIndex((day) => day === dayOfWeek)
        const previousDay =
          dayOfWeekOrder[dayIndex - 1] || dayOfWeekOrder[dayOfWeekOrder.length - 1]
        startTimeDayOfWeek = previousDay
      }
    }

    if (dataDto.endTime && dayOfWeek) {
      const endTimeLocal =
        dataDto.endTime instanceof Date ? moment(dataDto.endTime) : moment(dataDto.endTime, 'HH:mm')
      const endTimeUtc = moment(endTimeLocal).utc()

      // If UTC day differs from local day
      if (endTimeLocal.format('dddd') !== endTimeUtc.format('dddd')) {
        const dayIndex = dayOfWeekOrder.findIndex((day) => day === dayOfWeek)
        const previousDay =
          dayOfWeekOrder[dayIndex - 1] || dayOfWeekOrder[dayOfWeekOrder.length - 1]
        endTimeDayOfWeek = previousDay
      }
    }

    mapEntityProperties<BranchPeriodModel>(this, {
      startTime: formattedStartTime,
      endTime: formattedEndTime,
      startTimeDayOfWeek: startTimeDayOfWeek,
      endTimeDayOfWeek: endTimeDayOfWeek,
      status: dataDto.status,
      id: dataDto.id
    })
  }
}
